/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Global_Mapping_StatusInputs */

const en_global_mapping_status = /** @type {(inputs: Global_Mapping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global mapping status`)
};

const es_global_mapping_status = /** @type {(inputs: Global_Mapping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado de mapeo global`)
};

const fr_global_mapping_status = /** @type {(inputs: Global_Mapping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut du mappage global`)
};

const de_global_mapping_status = /** @type {(inputs: Global_Mapping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Globaler Mapping-Status`)
};

const ja_global_mapping_status = /** @type {(inputs: Global_Mapping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グローバルマッピングのステータス`)
};

const zh_global_mapping_status = /** @type {(inputs: Global_Mapping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全球映射状态`)
};

const ar_global_mapping_status = /** @type {(inputs: Global_Mapping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حالة التوجيه العالمي`)
};

const id_global_mapping_status = /** @type {(inputs: Global_Mapping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status pemetaan global`)
};

const it_global_mapping_status = /** @type {(inputs: Global_Mapping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stato di mappatura globale`)
};

const ru_global_mapping_status = /** @type {(inputs: Global_Mapping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус глобального распределения`)
};

const pt_global_mapping_status = /** @type {(inputs: Global_Mapping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status do mapeamento global`)
};

const ko_global_mapping_status = /** @type {(inputs: Global_Mapping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`글로벌 매핑 상태`)
};

/**
* | output |
* | --- |
* | "Global mapping status" |
*
* @param {Global_Mapping_StatusInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const global_mapping_status = /** @type {((inputs?: Global_Mapping_StatusInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Global_Mapping_StatusInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_global_mapping_status(inputs)
	if (locale === "es") return es_global_mapping_status(inputs)
	if (locale === "fr") return fr_global_mapping_status(inputs)
	if (locale === "de") return de_global_mapping_status(inputs)
	if (locale === "ja") return ja_global_mapping_status(inputs)
	if (locale === "zh") return zh_global_mapping_status(inputs)
	if (locale === "ar") return ar_global_mapping_status(inputs)
	if (locale === "id") return id_global_mapping_status(inputs)
	if (locale === "it") return it_global_mapping_status(inputs)
	if (locale === "ru") return ru_global_mapping_status(inputs)
	if (locale === "pt") return pt_global_mapping_status(inputs)
	return ko_global_mapping_status(inputs)
});